import { render, staticRenderFns } from "./NotificationCategoryChip.vue?vue&type=template&id=76264cfd&scoped=true"
import script from "./NotificationCategoryChip.vue?vue&type=script&lang=js"
export * from "./NotificationCategoryChip.vue?vue&type=script&lang=js"
import style0 from "./NotificationCategoryChip.vue?vue&type=style&index=0&id=76264cfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76264cfd",
  null
  
)

export default component.exports